const API_KEY = process.env.REACT_APP_API_KEY;
const APP_ID = process.env.REACT_APP_ID;
const LOGIN_NAME = process.env.REACT_APP_LOGIN_NAME;
const URL_API = process.env.REACT_APP_API_URL;

/**
 * The platform no longer wants APIKey / AppID / LoginName in request bodies
 * (backend instruction, same as web-app-v2): the app identifies itself with
 * x-app* headers and the session with the `From` token. Set
 * REACT_APP_LEGACY_BODY_AUTH=on to restore the old body fields, exactly as
 * before, if an environment still requires them.
 */
const LEGACY_BODY_AUTH =
  String(
    process.env.REACT_APP_LEGACY_BODY_AUTH || 'off',
  ).toLowerCase() === 'on';

const APP_VERSION = '1.0.0';

/** Same detection web-app-v2 sends in x-deviceos. */
const getDeviceOS = (): string => {
  const { userAgent, platform } = window.navigator;
  if (
    ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'].includes(platform)
  )
    return 'Mac';
  if (['iPhone', 'iPad', 'iPod'].includes(platform)) return 'iOS';
  if (['Win32', 'Win64', 'Windows', 'WinCE'].includes(platform))
    return 'Windows';
  if (/Android/.test(userAgent)) return 'Android';
  if (/Linux/.test(platform)) return 'Linux';
  return 'Unknown';
};

const appHeaders = (): Record<string, string> =>
  LEGACY_BODY_AUTH
    ? {}
    : {
        'x-appname': LOGIN_NAME || '',
        'x-apptype': 'web',
        'x-appversion': APP_VERSION,
        'x-deviceos': getDeviceOS(),
      };

const OSSIXRequestItem = {
  requestHeader: ({ token }: { token?: string }) => {
    return {
      'Content-Type': 'application/json',
      ...appHeaders(),
      ...(token ? { From: token } : {}),
    };
  },
  requestData: LEGACY_BODY_AUTH
    ? {
        APIKey: API_KEY,
        AppID: APP_ID,
        LoginName: LOGIN_NAME,
      }
    : {},
  url: URL_API,
};

export default {
  OSSIXRequestItem,
  AGBRequestItem: OSSIXRequestItem,
  // Add platform config
};
